export default __webpack_public_path__ + "7a7dec62eca1c594576502a34382c118.png";